<template>
  <div class="popup">
    <div class="popup-content">
      <div class="header">
        <h3>🍱 Quản lý món ăn</h3>
        <button @click="$emit('close')" class="close">&times;</button>
      </div>

      <!-- FORM -->
      <div class="form-section">
        <h4>{{ editingFood ? '✏️ Sửa món' : '➕ Thêm món mới' }}</h4>
        <div class="form">
          <input v-model="name" placeholder="Tên món"/>
          <input v-model.number="price" placeholder="Giá" type="number"/>
          <select v-model="category">
            <option disabled value="">Chọn danh mục</option>
            <option v-for="cat in categories" :key="cat.id" :value="cat.id">
              {{ cat.name }}
            </option>
          </select>

          <button class="btn" @click="submit">
            {{ editingFood ? '💾 Cập nhật món' : '➕ Thêm món' }}
          </button>
          <button v-if="editingFood" class="btn cancel" @click="cancelEdit">Huỷ sửa</button>
        </div>
      </div>

      <!-- DANH SÁCH MÓN -->
      <div class="list-section">
        <h4>📜 Danh sách món ăn ({{ foods.length }})</h4>
        <table>
          <thead>
          <tr>
            <th>#</th>
            <th>Tên món</th>
            <th>Giá</th>
            <th>Danh mục</th>
            <th>Thao tác</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(f, i) in foods" :key="f.id">
            <td>{{ i + 1 }}</td>
            <td>{{ f.name }}</td>
            <td>{{ formatMoney(f.price) }}</td>
            <td>{{ f.category.name }}</td>
            <td>
              <button class="edit" @click="editFood(f)">✏️</button>
            </td>
          </tr>
          <tr v-if="foods.length === 0">
            <td colspan="5" class="empty">Không có món nào.</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, defineEmits} from 'vue'
import {
  createFood,
  updateFood,
  getFoods,
  getCategory
} from '../services/foods.js'

const emit = defineEmits(['close', 'food-added'])
const categories = ref([])
const foods = ref([])

const id = ref('')
const name = ref('')
const price = ref('')
const category = ref('')
const editingFood = ref(null)

onMounted(async () => {
  categories.value = await getCategory()
  foods.value = await getFoods()
})

async function submit() {
  if (!name.value || !price.value || !category.value) {
    alert('⚠️ Vui lòng nhập đầy đủ thông tin!')
    return
  }
  const foodData = {
    id: id.value,
    name: name.value,
    price: price.value,
    category: {
      id: category.value
    }
  }
  console.log(foodData)
  console.log(category.value)
  if (editingFood.value) {
    await updateFood(foodData)
    // alert('✅ Đã cập nhật món!')
  } else {
    await createFood(foodData)
    // alert('✅ Đã thêm món mới!')
  }

  await reload()
  resetForm()
}

async function reload() {
  foods.value = await getFoods()
  emit('food-added')
}


function editFood(f) {
  editingFood.value = f
  id.value = f.id
  name.value = f.name
  price.value = f.price
  category.value = f.category.id
}

function cancelEdit() {
  editingFood.value = null
  resetForm()
}

function resetForm() {
  id.value = ''
  name.value = ''
  price.value = ''
  category.value = ''
  editingFood.value = null
}

function formatMoney(n) {
  return n ? n.toLocaleString('vi-VN') + '₫' : '0₫'
}
</script>

<style scoped>
/* --- Popup Layout --- */
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.popup-content {
  background: #fff;
  width: 90%;
  max-width: 900px;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  max-height: 90vh;
  overflow-y: auto;
  animation: slideIn 0.25s ease;
}

@keyframes slideIn {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 16px;
}

.close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #777;
}

/* --- Form --- */
.form-section {
  margin-bottom: 24px;
}

.form {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
}

input, select {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 15px;
  transition: 0.2s;
}

input:focus, select:focus {
  border-color: #00b894;
  outline: none;
}

.btn {
  grid-column: span 2;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #00b894, #00cec9);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.btn.cancel {
  background: #888;
}

.btn:hover {
  opacity: 0.9;
}

/* --- Table --- */
.list-section {
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

th, td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

th {
  background: #00b894;
  color: white;
  font-weight: 600;
}

td button {
  border: none;
  border-radius: 6px;
  padding: 5px 8px;
  cursor: pointer;
  font-size: 15px;
  margin-right: 6px;
}

td button.edit {
  background: #f39c12;
  color: #fff;
}

td button.delete {
  background: #e74c3c;
  color: #fff;
}

.empty {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 12px;
}
</style>
